// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parametersLabel_YFmbC {
  button[disabled],
  input[disabled],
  select[disabled],
  option[disabled],
  textarea[disabled] {
    background-color: transparent;
  }

  input,
  select,
  option,
  textarea {
    border: none;
    outline: none;
    background-color: var(--f4-background);
    padding: 12px;
    box-sizing: border-box;
  }
  input::placeholder,
  textarea::placeholder,
  select,
  option {
    color: var(--_71717a-color);
  }
}

.button_TK8Os {
  cursor: pointer;
  background-color: transparent;
  text-decoration: underline;
  font-weight: 600;
}
input {
  width: 100%;

  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  -ms-border-radius: 4px;
  -o-border-radius: 4px;
}
.parametersHeaderLabel_RtC1R{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}

.parameterNameValue_sBqxS{
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  div:first-child{

    input{
      font-size: 18px;
      width: 100%;
    }
  }
}
.searchIconsWrappers_OPAjK {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}

.parametersCounter_eiGMb {
  margin: 20px 0;
  display: flex;
  align-items: center;
  gap: 5px;
  color: var(--_10a37f-background);
  .icon_j0ZP0 {
    height: 10px;
    width: 10px;
    -webkit-transition: all 300ms;
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
  }
  .rotated_AZetY {
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    -o-transform: rotate(180deg);
  }
}


.editPencilContainer_wDaYN{
  border: 1px solid var(--cb-border);
  height: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
}
.grabInfoparameter_JcMLh{
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
}
.parameter_OQEyY {
  display: flex;
  gap: 10px;
  align-items: center;
  background-color: var(--white-background);
  border: 1px solid var(--ececf1-border);
  padding: 8px 16px;
  border-radius: 8px;
  justify-content: space-between;

  .grabIcon_zaIrZ {
    cursor: grab;
    outline: none;
    border: none;
    background-color: transparent;
  }
}
.parametersContainer_D0cw_ {
  transition: all 300ms;
  -webkit-transition: all 300ms;
  -moz-transition: all 300ms;
  -ms-transition: all 300ms;
  -o-transition: all 300ms;
  overflow: hidden;
  interpolate-size: allow-keywords;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.delete_GFqAC {
  background-color: var(--dc3545-background);
  height: 20px;
  min-width: 20px;
  max-width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  cursor: pointer;
  .icon_j0ZP0 {
    height: 13px;
    width: 13px;
  }
}

.AddUnit_ycWqd {
  display: flex;
  flex-direction: column;
  div {
    display: flex;
    align-items: center;
    width: fit-content;
    input {
      width: fit-content;
    }
  }
  input {
    width: 49%;
  }
  accent-color: var(--_10a37f-border);
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/ParametersLabel/ParametersLabel.module.css"],"names":[],"mappings":"AAAA;EACE;;;;;IAKE,6BAA6B;EAC/B;;EAEA;;;;IAIE,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,sBAAsB;EACxB;EACA;;;;IAIE,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,WAAW;;EAEX,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX;;IAEE;MACE,eAAe;MACf,WAAW;IACb;EACF;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC;IACE,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,uBAAuB;IACvB,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;EAC5B;EACA;IACE,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;EAC9B;AACF;;;AAGA;EACE,kCAAkC;EAClC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yCAAyC;EACzC,sCAAsC;EACtC,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;;EAE9B;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,6BAA6B;EAC/B;AACF;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB;MACE,kBAAkB;IACpB;EACF;EACA;IACE,UAAU;EACZ;EACA,mCAAmC;AACrC","sourcesContent":[".parametersLabel {\n  button[disabled],\n  input[disabled],\n  select[disabled],\n  option[disabled],\n  textarea[disabled] {\n    background-color: transparent;\n  }\n\n  input,\n  select,\n  option,\n  textarea {\n    border: none;\n    outline: none;\n    background-color: var(--f4-background);\n    padding: 12px;\n    box-sizing: border-box;\n  }\n  input::placeholder,\n  textarea::placeholder,\n  select,\n  option {\n    color: var(--_71717a-color);\n  }\n}\n\n.button {\n  cursor: pointer;\n  background-color: transparent;\n  text-decoration: underline;\n  font-weight: 600;\n}\ninput {\n  width: 100%;\n\n  border-radius: 4px;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  -ms-border-radius: 4px;\n  -o-border-radius: 4px;\n}\n.parametersHeaderLabel{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 10px 0;\n}\n\n.parameterNameValue{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n  div:first-child{\n\n    input{\n      font-size: 18px;\n      width: 100%;\n    }\n  }\n}\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n.parametersCounter {\n  margin: 20px 0;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: var(--_10a37f-background);\n  .icon {\n    height: 10px;\n    width: 10px;\n    -webkit-transition: all 300ms;\n    transform: rotate(0deg);\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n  }\n  .rotated {\n    transform: rotate(180deg);\n    -webkit-transform: rotate(180deg);\n    -moz-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    -o-transform: rotate(180deg);\n  }\n}\n\n\n.editPencilContainer{\n  border: 1px solid var(--cb-border);\n  height: 30px;\n  min-width: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  cursor: pointer;\n}\n.grabInfoparameter{\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 10px;\n}\n.parameter {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  background-color: var(--white-background);\n  border: 1px solid var(--ececf1-border);\n  padding: 8px 16px;\n  border-radius: 8px;\n  justify-content: space-between;\n\n  .grabIcon {\n    cursor: grab;\n    outline: none;\n    border: none;\n    background-color: transparent;\n  }\n}\n.parametersContainer {\n  transition: all 300ms;\n  -webkit-transition: all 300ms;\n  -moz-transition: all 300ms;\n  -ms-transition: all 300ms;\n  -o-transition: all 300ms;\n  overflow: hidden;\n  interpolate-size: allow-keywords;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.delete {\n  background-color: var(--dc3545-background);\n  height: 20px;\n  min-width: 20px;\n  max-width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  -webkit-border-radius: 50%;\n  -moz-border-radius: 50%;\n  -ms-border-radius: 50%;\n  -o-border-radius: 50%;\n  cursor: pointer;\n  .icon {\n    height: 13px;\n    width: 13px;\n  }\n}\n\n.AddUnit {\n  display: flex;\n  flex-direction: column;\n  div {\n    display: flex;\n    align-items: center;\n    width: fit-content;\n    input {\n      width: fit-content;\n    }\n  }\n  input {\n    width: 49%;\n  }\n  accent-color: var(--_10a37f-border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"parametersLabel": `parametersLabel_YFmbC`,
	"button": `button_TK8Os`,
	"parametersHeaderLabel": `parametersHeaderLabel_RtC1R`,
	"parameterNameValue": `parameterNameValue_sBqxS`,
	"searchIconsWrappers": `searchIconsWrappers_OPAjK`,
	"parametersCounter": `parametersCounter_eiGMb`,
	"icon": `icon_j0ZP0`,
	"rotated": `rotated_AZetY`,
	"editPencilContainer": `editPencilContainer_wDaYN`,
	"grabInfoparameter": `grabInfoparameter_JcMLh`,
	"parameter": `parameter_OQEyY`,
	"grabIcon": `grabIcon_zaIrZ`,
	"parametersContainer": `parametersContainer_D0cw_`,
	"delete": `delete_GFqAC`,
	"AddUnit": `AddUnit_ycWqd`
};
export default ___CSS_LOADER_EXPORT___;
